<div class="flex-column gap-widget">
	<div class="flex-space-between w-100 gap-L">
		<div class="w-100 top-widget-height">
			<div class="bg-rounded w-100 top-widget-height"
				 [tooltip]="'page.infrastructure.overview.kapsulTooltip' | translate"
				 [tooltipDisabled]="!!server && server.automatic">
				<application-mini-widget
					[displayQueryType]="false"
					[widget]="loadWidget"
					[title]="'page.infrastructure.overview.load' | translate"
					[type]="'neutralPercentage'"
					[displayTendency]="false"
				></application-mini-widget>
			</div>
		</div>
		<div class="w-100 top-widget-height">
			<div class="bg-rounded w-100 top-widget-height"
				 [tooltip]="'page.infrastructure.overview.kapsulTooltip' | translate"
				 [tooltipDisabled]="!!server && server.automatic">
				<application-mini-widget
					[displayQueryType]="false"
					[widget]="storageWidget"
					[title]="'page.infrastructure.overview.storage' | translate"
					[type]="'neutralPercentage'"
					[displayTendency]="false"
				></application-mini-widget>
			</div>
		</div>
		<div class="bg-rounded w-100 top-widget-height"
			 [tooltip]="'page.infrastructure.overview.kapsulTooltip' | translate"
			 [tooltipDisabled]="!!server && server.automatic">
			<div class="flex-column flex-space-between border-box-full pad-M">
				<div class="flex-align-center flex-space-between gap-S">
					<div class="flex flex-align-center gap-XS font-MM fw-700">
						<span>{{ 'page.infrastructure.overview.collect' | translate }}</span>
						<img *ngIf="agent && server.automatic" src="../../../../../../../assets/icons/info-black.svg" height="20"
							 class="filter-grey" [tooltipTriggerFor]="tooltip2">
						<app-tooltip #tooltip2>
							<div *ngIf="agent && server.automatic" class="flex-column" style="width: 200px">
								<div class="flex-space-between">
									<span>{{ 'page.infrastructure.overview.kapsulVersion' | translate }}</span>
									<span>{{ agent.version }}</span>
								</div>
								<div class="flex-space-between">
									<span>{{ 'page.infrastructure.overview.installationDate' | translate }}</span>
									<span>{{ formattedDate(agent.installDate) }}</span>
								</div>
							</div>
						</app-tooltip>
					</div>
				</div>

				<div class="flex-justify-end w-100">
					<div class="flex-column flex-align-end gap-XS mr-xs" style="max-width: 150px;">
						<div class="font-XL fw-500">
							@if (server && server.dataCollectionStatus === DataCollectionStatus.ACTIVE) {
								<span
									class="success font-XL">{{ 'page.infrastructure.overview.active' | translate }}</span>
							} @else if (server && server.dataCollectionStatus === DataCollectionStatus.OUTDATED) {
								<span class="warning">{{ 'page.infrastructure.overview.outdated' | translate }}</span>
							} @else if (server && server.dataCollectionStatus === DataCollectionStatus.ERROR) {
								<span class="error">{{ 'page.infrastructure.overview.inactive' | translate }}</span>
							}
						</div>
						<div class="font-S fw-700 grey mt-xs"
							 *ngIf="server && server.dataCollectionStatus === null">{{ 'global.noData' | translate }}
						</div>
						<div class="font-XS fw-500 grey"
							 *ngIf="server && server.dataCollectionStatus === null">{{ ('global.queryTypeHint.past_1_month') | translate }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="bg-rounded pad-M-M-0" style="padding-bottom: 5px">
		<app-server-information-form *ngIf="initialized"></app-server-information-form>
		<app-dashboard-page-loader *ngIf="!initialized"></app-dashboard-page-loader>
	</div>

	<div class="bg-rounded pad-M">
		<app-server-applications *ngIf="initialized"></app-server-applications>
		<app-dashboard-page-loader *ngIf="!initialized"></app-dashboard-page-loader>
	</div>

	<div class="bg-rounded pad-M">
		<app-server-log-preview *ngIf="tabActive && initialized"></app-server-log-preview>
		<app-dashboard-page-loader *ngIf="!initialized"></app-dashboard-page-loader>
	</div>
</div>
